<script>
	// let name = "hashsynth";
	export let h1 = "HASHSYNTH";
</script>

<header>
	<h1>
		<a href="/">
			{h1}
		</a>
	</h1>
</header>

<style>
	header {
		text-align: center;
		padding: 1rem;
		/* max-width: 320px; */
		margin: 0 auto;
	}

	h1 {
		color: #e84757;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
		font-family: 'Orbitron';
	}
	h1 a {
		color: inherit;
	}

	@media (max-width: 480px) {
		h1 {
			font-size: 10vw;
			letter-spacing: .25vw;
		}
	}
	@media (min-width: 640px) {
		header {
			max-width: none;
		}
	}
</style>